import { useState, useEffect, useMemo, useContext, useRef, useCallback } from 'react';
import _ from 'underscore';
import services from '../../../services/services';
import { Urls } from '../../../services/Urls';
import { ToastContext } from '../../../context/ToastContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';



export const useMaster = (props) => {

    const tagRef = useRef();
    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [columnDefs, setColumnDefs] = useState([]);
    const [rowData, setRowData] = useState({
        allData: [],
        filterData: []
    });
    const currentRowData = useRef([])
    const columndata = useRef({})
    const gridRef = useRef(null);
    const [showDelete, setshowDelete] = useState(false);
    const currentData = useRef('')
    const isNewRow = useRef(false);
    const isPrimaryKey = useRef('');
    const entityId = useRef('');
    const [loader, setLoader] = useState(false);
    const [testData, setTestData] = useState([]);
    const [lastEditedRow, setLastEditedRow] = useState(null);
    const gridApiRef = useRef(null);
    const [filterText, setFilterText] = useState('')


    useEffect(() => {
        getTableEntityData()
    }, [props.currentSelectedMaster])

    const onFilterTextBoxChanged = useCallback(() => {
        gridRef?.current?.api.setGridOption("quickFilterText", document.getElementById("filter-text-box").value,);
    }, []);


    useEffect(() => {
        if (filterText) {
            const lowerSearch = filterText.toLowerCase();
            const filtered = rowData?.allData?.filter(row =>
                Object.values(row).some(val =>
                    val && val.toString().toLowerCase().includes(lowerSearch)
                )
            );
            setRowData((prev) => ({ ...prev, filterData: filtered }));
            setTestData(JSON.parse(JSON.stringify(filtered)));
        } else {
            setRowData((prev) => ({ ...prev, filterData: rowData?.allData }));
            setTestData(JSON.parse(JSON.stringify(rowData?.allData)));
        }
    }, [filterText]);

    const getTableEntityData = async () => {
        setColumnDefs([])
        setRowData({
            allData: [],
            filterData: []
        })
        setTestData([])
        currentRowData.current = []
        try {
            setLoader(true)
            const payload = {
                "entity_metadata_id": props.currentSelectedMaster.entity_metadata_id
            }
            const res = await services.getInvokeRemote("POST", Urls("GETTABLEENTITYDATA"), payload);
            if (res?.body?.data) {
                setTestData(JSON.parse(JSON.stringify(res.body.data.table2)));
                isPrimaryKey.current = res?.body?.data?.table_primarykey_data[0]?.name
                if (!_.isEmpty(res.body.data.table_column)) {
                    const columnData = [];
                    entityId.current = res.body.data.table_column[0].entity_metadata_id
                    res.body.data.table_column.forEach(data => {
                        columndata.current[data.name] = data.column_id;
                        let column = {
                            field: data.name,
                            headerName: data.column_display_name,
                            order_number: data?.column_display_id,
                            width: data.column_width === 0 ? '100px' : data.column_width,
                            headerClass: (data.alignment === '' || data.alignment === 'l') ? 'left ag-header-cell-label' :
                                data.alignment === 'r' ? 'right ag-header-cell-label' :
                                    data.alignment === 'c' ? 'center ag-header-cell-label' :
                                        'left ag-header-cell-label',
                            suppressHeaderMenuButton: true,
                            editable: (params) => !_.some(res?.body?.data?.table_primarykey_data, item => item.name === params.colDef.field) || (_.findWhere(res?.body?.data?.table_primarykey_data, { name: params.colDef.field })?.is_identity === 0),
                            valueParser: (params) => {
                                if (params.newValue === '' || params.newValue === null) {
                                    return '';
                                }
                                return data.dtype === 'bit' ? params.newValue === true : params.newValue;
                            },
                            cellRenderer: data.dtype === 'bit' && 'agCheckboxCellRenderer',
                            cellEditor: data.dtype === 'bit' ? 'agCheckboxCellEditor' : 'agTextCellEditor',
                            tooltipValueGetter: (params) => {
                                if (!_.some(res?.body?.data?.table_primarykey_data, item => item.name === params.colDef.field) || (_.findWhere(res?.body?.data?.table_primarykey_data, { name: params.colDef.field })?.is_identity === 0)) {
                                    return "double click to edit";
                                }
                                return null;
                            }

                        };
                        columnData.push(column);
                    });
                    // Add delete column
                    columnData.push({
                        field: isPrimaryKey.current,
                        headerName: 'Delete',
                        cellStyle: { textAlign: 'center' },
                        width: '50px',
                        suppressHeaderMenuButton: true,
                        cellRenderer: function (params) {
                            return (
                                <div>
                                    <FontAwesomeIcon icon="fa-solid fa-trash"
                                        onClick={() => {
                                            setLastEditedRow(null)
                                            setshowDelete(true);
                                            currentData.current = params;
                                        }}
                                    />
                                </div>
                            );
                        }
                    });
                    // Set column definitions and row data
                    setColumnDefs(_.sortBy(columnData, 'order_number'));
                    JSON.parse(JSON.stringify(rowData?.filterData))
                    setRowData({ allData: JSON.parse(JSON.stringify(res.body.data.table2)), filterData: res.body.data.table2 });


                } else {
                    showInfo('Info', 'No config');
                    props.handleConfig('No Config');
                }
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("Error getting table entity List: ", error);
        }
    }


    const capitalizeHeader = (header) => {
        const spaced = header.replace(/([A-Z])/g, ' $1').replace(/_/g, ' ');
        return spaced.replace(/\b\w/g, char => char.toUpperCase()).trim();
    };


    const getExcelDownload = async () => {
        if (_.isEmpty(rowData?.filterData)) {
            showInfo("Info", "There is no data to download");
            return;
        }
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Dynamic_Data_Export');
        const headers = Object.keys(rowData?.filterData?.[0]).map(capitalizeHeader);
        worksheet.addRow(headers);
        worksheet.addRow(new Array(headers.length).fill(''));

        rowData?.filterData?.forEach(row => {
            const rowValues = Object.keys(row).map(key => row[key]);
            worksheet.addRow(rowValues);
        });

        worksheet.columns.forEach((col, idx) => {
            col.width = Math.max(headers[idx].length * 1.2, 15);
        });

        worksheet.getRow(1).eachCell(cell => {
            cell.font = { bold: true };
        });

        const fileName = "Dynamic_Data_Export.xlsx";
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        saveAs(blob, fileName);
    };

    const onCellValueChanged = (event) => {
        const { rowIndex } = event;
        if (lastEditedRow !== undefined && lastEditedRow !== null && lastEditedRow !== rowIndex) {
            if (!_.isEqual(testData[lastEditedRow], rowData?.filterData?.[lastEditedRow])) {
                handleInputchange(rowData?.filterData?.[lastEditedRow]);
                setLastEditedRow(null)
            }
        }
        setLastEditedRow(rowIndex);

    };

    const handleClickOutside = () => {
        if (gridApiRef.current) {
            gridApiRef.current.stopEditing();
        }

        if (lastEditedRow !== undefined && lastEditedRow !== null) {
            if (!_.isEqual(testData[lastEditedRow], rowData?.filterData?.[lastEditedRow])) {
                handleInputchange(rowData?.filterData?.[lastEditedRow]);
                setLastEditedRow(null)
            }
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [lastEditedRow]);



    const handleInputchange = async (params) => {
        try {
            const payload = {
                "entity_metadata_id": props.currentSelectedMaster.entity_metadata_id,
                "key_value": []
            };

            for (const key in params) {
                const columnId = columndata?.current?.[key];
                const columnValue = params[key];
                if (!columnId) continue;
                if (columnValue === "" || columnValue === null || columnValue === undefined) {
                    continue;
                }
                payload.key_value.push({
                    "entity_column_id": columnId,
                    "column_value": columnValue
                });
            }
            if (payload.key_value.length === 0) {
                return null;
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTTABLEENTITYDATA"), payload);
            if (res.body.data) {
                setTestData(JSON.parse(JSON.stringify(rowData?.filterData)))
                setLastEditedRow(null)
                showSuccess("Success", res.body.message);
                const updatedAllData = rowData?.allData?.map(item => {
                    if (item[isPrimaryKey.current] === params[isPrimaryKey.current]) {
                        return { ...params };
                    }
                    return item;
                });

                setRowData((prev) => ({ ...prev, allData: updatedAllData }));
                if (isNewRow.current) {
                    if (gridRef.current.props.rowData[0].hasOwnProperty(isPrimaryKey.current)) {
                        gridRef.current.props.rowData[0][isPrimaryKey.current] = res.body.data.table_columns[0]?.insertedID
                    }
                    isNewRow.current = false
                    const rowNode = gridRef.current.api.getDisplayedRowAtIndex(0);
                    rowNode.setData([...currentRowData.current][0]);
                }
            }
        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
            console.error("Error getting tables list: ", error);
        }
    }


    const isLastRowFilled = () => {
        const rowCount = gridRef.current.api.getDisplayedRowCount();
        if (rowCount === 0) return false;
        const lastRowData = gridRef.current.api.getDisplayedRowAtIndex(0)?.data;
        return Object.values(lastRowData).every(value => !value)
    }



    const addNewRecord = async () => {

        const gridData = [...rowData?.filterData]
        const data = await isLastRowFilled()
        if (!data) {
            let jsObject = {}
            columnDefs.map(col => {
                if (col.headerName !== 'Delete') {
                    jsObject[col.field] = ''
                }
            })
            gridData.unshift(jsObject)
            setRowData((prevState) => ({ ...prevState, filterData: [jsObject, ...prevState?.filterData] }))
            setTestData(JSON.parse(JSON.stringify([jsObject, ...testData])));
            currentRowData.current = gridData
            isNewRow.current = true
        } else {
            showInfo('Info', 'Row Is Already Added')
        }
    }

    const handleDeleteTableEntityData = async (rowdata) => {
        try {
            const payload = {
                "entity_metadata_id": entityId.current,
                "primary_key_value": rowdata.data[isPrimaryKey.current]
            };

            const res = await services.getInvokeRemote("POST", Urls("DELETETABLEENTITYDATA"), payload);

            if (res?.body?.data) {
                setshowDelete(false);
                showSuccess("Success", res.body.message);
                const targetId = rowdata.data[isPrimaryKey.current];
                setRowData((prev) => ({
                    ...prev,
                    allData: prev?.allData?.filter(item => item[isPrimaryKey.current] !== targetId) || [],
                    filterData: prev?.filterData?.filter(item => item[isPrimaryKey.current] !== targetId) || []
                }));
                if (gridRef.current?.api) {
                    gridRef.current.api.applyTransaction({ remove: [rowdata.data] });
                }
            }
        } catch (error) {
            showError("Error", error?.response?.data?.errorMessage);
            console.error("Error Deleting Master: ", error);
        }
    }


    return useMemo(() => ({
        setLastEditedRow, gridApiRef, onCellValueChanged, addNewRecord, rowData, columnDefs, gridRef, loader, showDelete, setshowDelete, handleDeleteTableEntityData, currentData, getExcelDownload, tagRef, onFilterTextBoxChanged, setFilterText
    }), [setLastEditedRow, gridApiRef, onCellValueChanged, addNewRecord, rowData, columnDefs, gridRef, loader, showDelete, setshowDelete, handleDeleteTableEntityData, currentData, getExcelDownload, tagRef, onFilterTextBoxChanged, setFilterText])

}